import React, { useEffect } from 'react';
import { exists } from 'lib/types';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from 'redux/hooks';
import { selectActiveOrganization, selectUser } from 'redux/auth';
import RouterTabs from 'lib/components/RouterTabs';
import {
  CUSTOMER_REPORTS_ROUTE,
  CUSTOMER_REPORTS_ROUTES,
  PUB_REPORTS_ROUTE,
  PUB_REPORTS_ROUTES
} from 'router/routes';
import { OccupationType } from 'lib/enums';
import { useValidReportsTabs } from './hooks/useValidReportsTabs';
import {
  ReportsLoadingProvider,
  useReportsLoading
} from './context/LoadingContext';
import { ReportParamsProvider } from './context/ReportParamsContext';

function ColumnReportsContent() {
  const { pathname } = useLocation();
  const activeOrganization = useAppSelector(selectActiveOrganization);
  const user = useAppSelector(selectUser);
  const { setLoading } = useReportsLoading();

  const validTabs = useValidReportsTabs();

  useEffect(() => {
    if (!exists(activeOrganization) || !exists(user)) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [activeOrganization, user, setLoading]);

  const relevantReportRoute =
    user?.data().occupation === OccupationType.publishing.value
      ? { root: PUB_REPORTS_ROUTE, routes: PUB_REPORTS_ROUTES }
      : { root: CUSTOMER_REPORTS_ROUTE, routes: CUSTOMER_REPORTS_ROUTES };

  const atRelativeRoot = pathname === relevantReportRoute.root;
  const userCanViewTab = !!validTabs.find(t =>
    pathname.startsWith(t.path.split('?')[0])
  )?.enabled;

  const needsRedirect = atRelativeRoot || !userCanViewTab;

  if (needsRedirect) {
    const firstValidTab = validTabs.find(t => t.enabled);
    const redirectTo = firstValidTab
      ? firstValidTab.path
      : relevantReportRoute.routes.PRODUCTS;

    return <Navigate to={redirectTo} replace />;
  }

  return (
    <RouterTabs
      tabs={validTabs}
      id="reports-sidebar-tabs"
      hideDisabled
      sidebar
      preserveSearchParams
    />
  );
}

function ColumnReports() {
  return (
    <ReportsLoadingProvider>
      <ReportParamsProvider>
        <ColumnReportsContent />
      </ReportParamsProvider>
    </ReportsLoadingProvider>
  );
}
export default ColumnReports;
